import { PropertyData } from '@aloft/toolkit-shared';

import { PropertyGridField } from '../../../components/PropertyGrid/types.ts';

export type ImprovementField = PropertyGridField<PropertyData['editableData']['improvements']>;
export const improvementsFieldName = 'editableData.improvements';
